export const readIsAdmin = (state) => state.profile.role_id == 1;
export const readIsLeader = (state) => state.profile.role_id == 16;
export const readUpdated = (state) => state.profile.basic_info;
export const readUser = (state) => state.profile;
export const readError = (state) => {
	return state.error;
};
